import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./Route/AppRoutes";
import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/all.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import WeekCalender from "./Components/Calendar/WeekCalender";
function App() {
  return (
    <div className="App">
        <BrowserRouter>
          <AppRoutes />
          {/* <WeekCalender /> */}
        </BrowserRouter>
    </div>
    
  );
}

export default App;
